import { render, staticRenderFns } from "./preview-pythonfile.vue?vue&type=template&id=792b3dbc&scoped=true"
import script from "./preview-pythonfile.vue?vue&type=script&lang=js"
export * from "./preview-pythonfile.vue?vue&type=script&lang=js"
import style0 from "./preview-pythonfile.vue?vue&type=style&index=0&id=792b3dbc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "792b3dbc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('792b3dbc')) {
      api.createRecord('792b3dbc', component.options)
    } else {
      api.reload('792b3dbc', component.options)
    }
    module.hot.accept("./preview-pythonfile.vue?vue&type=template&id=792b3dbc&scoped=true", function () {
      api.rerender('792b3dbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/viewsteacher/teacher/preview-pythonfile.vue"
export default component.exports